/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MailOnsGebruikerGegevensDto } from '../models/mail-ons-gebruiker-gegevens-dto';
import { MailOnsSendMailRequestDto } from '../models/mail-ons-send-mail-request-dto';
import { SendMailResultDto } from '../models/send-mail-result-dto';

@Injectable({
  providedIn: 'root',
})
export class MailOnsApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getGebruikergegevensByAlvnummer
   */
  static readonly GetGebruikergegevensByAlvnummerPath = '/api/extern/mail-ons/get-gebruikergegevens';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGebruikergegevensByAlvnummer$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGebruikergegevensByAlvnummer$Plain$Response(params?: {
    alvnummer?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<MailOnsGebruikerGegevensDto>> {

    const rb = new RequestBuilder(this.rootUrl, MailOnsApiService.GetGebruikergegevensByAlvnummerPath, 'get');
    if (params) {
      rb.query('alvnummer', params.alvnummer, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MailOnsGebruikerGegevensDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGebruikergegevensByAlvnummer$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGebruikergegevensByAlvnummer$Plain(params?: {
    alvnummer?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<MailOnsGebruikerGegevensDto> {

    return this.getGebruikergegevensByAlvnummer$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MailOnsGebruikerGegevensDto>) => r.body as MailOnsGebruikerGegevensDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGebruikergegevensByAlvnummer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGebruikergegevensByAlvnummer$Response(params?: {
    alvnummer?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<MailOnsGebruikerGegevensDto>> {

    const rb = new RequestBuilder(this.rootUrl, MailOnsApiService.GetGebruikergegevensByAlvnummerPath, 'get');
    if (params) {
      rb.query('alvnummer', params.alvnummer, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MailOnsGebruikerGegevensDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGebruikergegevensByAlvnummer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGebruikergegevensByAlvnummer(params?: {
    alvnummer?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<MailOnsGebruikerGegevensDto> {

    return this.getGebruikergegevensByAlvnummer$Response(params).pipe(
      map((r: StrictHttpResponse<MailOnsGebruikerGegevensDto>) => r.body as MailOnsGebruikerGegevensDto)
    );
  }

  /**
   * Path part for operation sendMail
   */
  static readonly SendMailPath = '/api/extern/mail-ons/send-mail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendMail$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendMail$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: MailOnsSendMailRequestDto
  }): Observable<StrictHttpResponse<SendMailResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, MailOnsApiService.SendMailPath, 'post');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SendMailResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendMail$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendMail$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: MailOnsSendMailRequestDto
  }): Observable<SendMailResultDto> {

    return this.sendMail$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SendMailResultDto>) => r.body as SendMailResultDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendMail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendMail$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: MailOnsSendMailRequestDto
  }): Observable<StrictHttpResponse<SendMailResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, MailOnsApiService.SendMailPath, 'post');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SendMailResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendMail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendMail(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: MailOnsSendMailRequestDto
  }): Observable<SendMailResultDto> {

    return this.sendMail$Response(params).pipe(
      map((r: StrictHttpResponse<SendMailResultDto>) => r.body as SendMailResultDto)
    );
  }

  /**
   * Path part for operation deleteFile
   */
  static readonly DeleteFilePath = '/api/extern/mail-ons/delete-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFile$Response(params?: {
    file?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MailOnsApiService.DeleteFilePath, 'post');
    if (params) {
      rb.query('file', params.file, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFile(params?: {
    file?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<void> {

    return this.deleteFile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
